import React from 'react';
import { Stepper, Step, StepLabel, StepConnector } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

/**
 * This method will generate classes (by Material UI) with additional theme or style attribute
 *
 * @type {function}
 * @returns {Object}  material ui generated classes
 */
const useStyles = makeStyles((/* theme */) => ({
    root: props => ({
        width: '100%',
        padding: '.5rem',
        ...props.root
    })
}));

const useStepStyles = makeStyles((/* theme */) => ({
    root: props => ({
        ...props.root
    })
}));

const useStepConnectorStyles = makeStyles((/* theme */) => ({
    root: props => ({
        ...props.root
    })
}));

const useStepLabelStyles = makeStyles((/* theme */) => ({
    root: props => ({
        ...props.root
    }),
    labelContainer: props => ({
        ...props.labelContainer
    }),
    active: props => ({
        ...props.active
    }),
    completed: props => ({
        ...props.completed
    })
}));

const useStepIconStyles = makeStyles((/* theme */) => ({
    root: props => ({
        ...props.root
    }),
    text: props => ({
        ...props.text
    }),
    active: props => ({
        ...props.active
    }),
    completed: props => ({
        ...props.completed
    })
}));

/**
 * Steps component that implements MUI stepper
 * @param {Object} props - props
 * @returns {*} Steps
 * @constructor
 */
export default function Steps(props) {
    const {
        steps = [],
        activeStep = 0,
        classes = {},
        styles = {},
        orientation = 'horizontal'
    } = props;

    const muiClasses = useStyles(styles.stepper);
    const muiClassesStep = useStepStyles(styles.step);
    const muiClassesStepConnector = useStepConnectorStyles(styles.stepConnector);
    const muiClassesStepIcon = useStepIconStyles(styles.stepIcon);
    const muiClassesStepLabel = useStepLabelStyles(styles.stepLabel);

    return (
        <Stepper
            activeStep={ activeStep }
            orientation={ orientation }
            className={ `${muiClasses.root}${classes.root ? ' ' + classes.root : ''}` }
            connector={
                <StepConnector
                    classes={{
                        root: `${muiClassesStepConnector.root}${classes.stepConnector ? ' ' + classes.stepConnector : ''}`
                    }}
                />
            }
        >
            { steps.map((label, index) =>
                <Step
                    key={ `step-${index}` }
                    classes={{
                        root: `${muiClassesStep.root}${classes.stepRoot ? ' ' + classes.stepRoot : ''}`
                    }}
                >
                    <StepLabel
                        StepIconProps={{
                            classes: {
                                root: `${muiClassesStepIcon.root}${classes.stepIcon && classes.stepIcon.root ? ' ' + classes.stepIcon.root : ''}`,
                                text: `${muiClassesStepIcon.text}${classes.stepIcon && classes.stepIcon.text ? ' ' + classes.stepIcon.text : ''}`,
                                active: `${muiClassesStepIcon.active}${classes.stepIcon && classes.stepIcon.active ? ' ' + classes.stepIcon.active : ''}`,
                                completed: `${muiClassesStepIcon.completed}${classes.stepIcon && classes.stepIcon.completed ? ' ' + classes.stepIcon.completed : ''}`
                            }
                        }}
                        classes={{
                            root: `${muiClassesStepLabel.root}${classes.stepLabel && classes.stepLabel.root ? ' ' + classes.stepLabel.root : ''}`,
                            labelContainer: `${muiClassesStepLabel.labelContainer}${classes.stepLabel && classes.stepLabel.labelContainer ? ' ' + classes.stepLabel.labelContainer : ''}`,
                            active: `${muiClassesStepLabel.active}${classes.stepLabel && classes.stepLabel.active ? ' ' + classes.stepLabel.active : ''}`,
                            completed: `${muiClassesStepLabel.completed}${classes.stepLabel && classes.stepLabel.completed ? ' ' + classes.stepLabel.completed : ''}`
                        }}
                    >
                        { label }
                    </StepLabel>
                </Step>)}
        </Stepper>
    );
}
